import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ParticipantLayout from "./layout/ParticipantLayout";
import Dashboard from "./dashboard/Dashboard";
import Profile from "./profile/Profile";
import ParticipantProtectedRoute from "../Auth/ParticipantProtectedRoute";
import LearningPaths from "./learning-paths/LearningPaths";
import LearningPathDetail from "./learning-paths/LearningPathDetail";
import CourseModules from "./learning-paths/CourseModules";
import ModulePlayer from "./learning-paths/ModulePlayer";
import Support from "./support/Support";
import Achievements from "./achievements/Achievements";

const ParticipantRoutes = () => {
  return (
    <Routes>
      <Route
        element={
          <ParticipantProtectedRoute>
            <ParticipantLayout />
          </ParticipantProtectedRoute>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="courses-and-learning-path" element={<LearningPaths />} />
        <Route
          path="courses-and-learning-path/:trackerId/:learningPathId"
          element={<LearningPathDetail />}
        />
        <Route
          path="courses-and-learning-path/:trackerId/:learningPathId/courses/:courseId"
          element={<CourseModules />}
        />
        <Route path="module-player" element={<ModulePlayer />} />
        <Route path="feedback-and-support" element={<Support />} />
        <Route path="achievements" element={<Achievements />} />
        <Route
          path="interhouse-sport"
          element={<Navigate to="dashboard" replace />}
        />
        <Route path="profile" element={<Profile />} />
        
        {/* Default redirect to dashboard if hitting /participant */}
        <Route path="" element={<Navigate to="dashboard" replace />} />
      </Route>
    </Routes>
  );
};

export default ParticipantRoutes;
